export const linenedges = {
  FETCH_ALL_ARTICLES: 'FETCH_ALL_ARTICLES',
  FETCH_LATEST_ARTICLES:'FETCH_LATEST_ARTICLES',
  FETCH_AN_ARTICLE: 'FETCH_AN_ARTICLE',
  FETCH_RELATED_ARTICLES: 'FETCH_RELATED_ARTICLES',
  FETCH_ALL_CASESTUDIES: 'FETCH_ALL_CASESTUDIES',
  FETCH_LATEST_CASESTUDIES: 'FETCH_LATEST_CASESTUDIES',
  FETCH_A_CASESTUDY: 'FETCH_A_CASESTUDY',
  APP_LOADING: 'APP_LOADING'
}